import axios from 'axios'
import router from '../router/index.js'
// 此时需要自行下载一下qs
import qs from 'qs'

import Vue from 'vue' // 引入Vue

import RCLoading from "../common/RCLoading/RCLoading.js"; // 引入Vant的Toast组件

//判断是否是生产环境
// var isPro = process.env.NODE_ENV === "production" //process.env.NODE_ENV用于区分是生产环境还是开发环境
//配置不同的baseURL
// 原理：
// 在生产环境(给客户部署项目)下使用的是"/weixin-api"(后端给的路径域名后边的部分)，此时会自动拿到ip地址 + /weixin-api(路径拼接)，在本地跑项目时拿到的时/api 也就是vue.config.js配置跨域下的路径；

let baseURL = '/bapi' // 

const service = axios.create({
	baseURL: baseURL,
	timeout: 90000 // 请求超时时间
})
// 请求拦截器
service.interceptors.request.use(
	(config) => {
		// 在请求发送之前做一些处理
		if (!(config.headers['Content-Type'])) {
			if (config.method == 'post') {
				config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
				config.headers['Access-Token-X'] = sessionStorage.getItem('token')
				config.headers['channel'] = 'cmbcffydcc'
				for (var key in config.data) {
					if (config.data[key] === '') {
						delete config.data[key]
					}
				}
				// qs用于序列化data传输的数据 不然后端拿到的话会出现data数据套了一层拿不到数据的问题
				config.data = qs.stringify(config.data)
			} else {
				config.headers['Content-Type'] =
					'application/x-www-form-urlencoded;charset=UTF-8'
				// config.params
			}
		}
		const token = sessionStorage.getItem('token')

		// 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
		if (token) {
			config.headers['token'] = token
		}
		return config
	},
	(error) => {
		// 发送失败
		// console.log('发送失败', error)
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	(response) => {
		// console.log('response',response,RCLoading);
		if (response.data && response.data.code == 200) {
			return Promise.resolve(response.data)
		} else {
			Vue.prototype.$toast({
				message: response.data.msg ? response.data.msg : response.data,
				duration: 2000, // 提示时长
				forbidClick: true, // 禁止点击遮罩层穿透
			})
			RCLoading.hide()
			return Promise.reject(response)
		}
	},
	(error) => {
		Vue.prototype.$toast({
			message: "网络异常，请检查",
			duration: 2000, // 提示时长
			forbidClick: true, // 禁止点击遮罩层穿透
		})
		RCLoading.hide()
		return Promise.reject(error)
	}
)

export default service


// WEBPACK FOOTER //
// ./src/api/request.js